/* 3RD MAY Tippspiel – native Theme-Section-Logik. */
(function () {
  function init(root) {
    if (!root || root.dataset.tspInit === "1") return;
    root.dataset.tspInit = "1";

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector(".tsp-config").textContent); } catch (e) {}
    var KLAVIYO_KEY = cfg.klaviyoPublicKey || "";
    var LIST_ID = cfg.klaviyoListId || "";
    var ODDS_URL = (cfg.oddsUrl || "").replace(/\/+$/, "");
    var MATCH = cfg.match || "Schweiz-Kolumbien";

    var seed = cfg.seed || {
      "1:0":142,"2:1":118,"1:1":96,"2:0":88,"0:1":61,"1:2":54,"0:0":47,
      "3:1":41,"2:2":33,"3:0":28,"0:2":24,"3:2":19,"1:3":12,"4:1":9,"2:3":8
    };
    var live = null;
    var isDemo = true;
    var score = { h: 1, a: 0 };
    var submitted = false;

    var $ = function (s) { return root.querySelector(s); };
    var key = function () { return score.h + ":" + score.a; };

    function paintScore() {
      $("#tsp-scoreH").textContent = score.h;
      $("#tsp-scoreA").textContent = score.a;
      $("#tsp-srscore").textContent = "Zwischenstand Schweiz " + score.h + " zu " + score.a + " Kolumbien";
    }

    function loadOdds() {
      if (!ODDS_URL) return;
      fetch(ODDS_URL + "/odds").then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.scores && Object.keys(d.scores).length) { live = d.scores; isDemo = false; }
      }).catch(function () {});
    }

    function renderOdds() {
      var src = live || seed;
      var counts = Object.assign({}, src), k = key();
      counts[k] = (counts[k] || 0) + 1;
      var total = 0, entries = [];
      for (var s in counts) total += counts[s];
      for (var s2 in counts) entries.push([s2, counts[s2]]);
      entries.sort(function (a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); });
      var top = entries.slice(0, 6);
      if (!top.some(function (e) { return e[0] === k; })) { top.push([k, counts[k]]); top.sort(function (a, b) { return b[1] - a[1]; }); }
      var maxCount = entries[0][1];
      var html = "";
      top.forEach(function (e) {
        var pct = Math.round(e[1] / total * 100);
        var w = Math.round(e[1] / maxCount * 100);
        var you = e[0] === k ? " you" : "";
        var lbl = e[0] + (you ? ' <span class="sr-only">– dein Tipp</span>' : "");
        html += '<div class="bar' + you + '"><span class="bl num">' + lbl + '</span>'
          + '<span class="track"><span class="fill" style="width:' + Math.max(w, 4) + '%"></span></span>'
          + '<span class="pct num">' + pct + '%</span></div>';
      });
      $("#tsp-bars").innerHTML = html;
      $(".tsp-demo").textContent = isDemo ? "Vorschau · Beispieldaten" : "Live";
      var yourPct = Math.round(counts[k] / total * 100);
      var rank = entries.findIndex(function (e) { return e[0] === k; }) + 1;
      var lead = rank === 1 ? "Dein Tipp ist gerade der Favorit der Community."
        : (rank <= 3 ? "Dein Tipp liegt auf Rang " + rank + " – gute Gesellschaft."
        : "Du tippst gegen den Strom – das kann sich lohnen.");
      var pre = isDemo ? "In dieser Vorschau tippen " : "";
      var share = yourPct < 1 ? (isDemo ? "In dieser Vorschau tippt fast niemand <b>" + k + "</b> wie du. " : "Fast niemand tippt <b>" + k + "</b> wie du. ")
        : pre + "<b>" + yourPct + "%</b> tippen <b>" + k + "</b> wie du. ";
      $("#tsp-younote").innerHTML = share + lead;
    }

    Array.prototype.forEach.call(root.querySelectorAll(".stepper button"), function (btn) {
      btn.addEventListener("click", function () {
        var t = btn.getAttribute("data-team") === "h" ? "h" : "a";
        var d = parseInt(btn.getAttribute("data-d"), 10);
        score[t] = Math.min(9, Math.max(0, score[t] + d));
        paintScore();
      });
    });

    function postTip(email) {
      var payload = { score: key(), match: MATCH };
      if (ODDS_URL) {
        fetch(ODDS_URL + "/tip", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).catch(function () {});
      }
      try {
        if (window.klaviyo) {
          window.klaviyo.push(["identify", { $email: email }]);
          window.klaviyo.push(["track", "Placed Tip", payload]);
        }
      } catch (e) {}
      if (!KLAVIYO_KEY || !LIST_ID) return Promise.resolve();
      var body = {
        data: {
          type: "subscription",
          attributes: {
            profile: { data: { type: "profile", attributes: {
              email: email,
              properties: { tipp_score: payload.score, tipp_match: MATCH }
            } } }
          },
          relationships: { list: { data: { type: "list", id: LIST_ID } } }
        }
      };
      return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(KLAVIYO_KEY), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify(body)
      });
    }

    $(".tsp-form").addEventListener("submit", function (e) {
      e.preventDefault();
      if (submitted) return;
      var email = $("#tsp-email"), consent = $("#tsp-consent"), err = $("#tsp-err");
      email.value = email.value.trim();
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!re.test(email.value)) { err.textContent = "Bitte gib eine gültige E-Mail-Adresse ein."; email.focus(); return; }
      if (!consent.checked) { err.textContent = "Bitte bestätige die Benachrichtigung, um teilzunehmen."; consent.focus(); return; }
      err.textContent = "";
      submitted = true;
      $(".submit").setAttribute("aria-busy", "true");

      postTip(email.value).catch(function () {}).then(function () {
        $(".tsp-form").classList.add("hidden");
        $("#tsp-rcH").textContent = score.h;
        $("#tsp-rcA").textContent = score.a;
        Array.prototype.forEach.call(root.querySelectorAll(".stepper button"), function (b) { b.disabled = true; });
        loadOdds();
        setTimeout(renderOdds, 250);
        renderOdds();
        $("#tsp-reveal").classList.remove("hidden");
        $("#tsp-reveal").scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });

    paintScore();
    loadOdds();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll(".tsp[data-section-type=tippspiel]"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".tsp[data-section-type=tippspiel]");
    if (el) init(el);
  });
})();